export const GET_TENANTS = 'GET_TENANTS';
export const ADD_TENANT = 'ADD_TENANT';
export const UPDATE_TENANT = 'UPDATE_TENANT';
export const DELETE_TENANT = 'DELETE_TENANT';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const GET_TENANT_STATS = 'GET_TENANT_STATS';
